const local: App.I18n.Schema = {
  system: {
    title: import.meta.env.VITE_APP_TITLE,
    updateTitle: '系统版本更新通知',
    updateContent: '检测到系统有新版本发布，是否立即刷新页面？',
    updateConfirm: '立即刷新',
    updateCancel: '稍后再说'
  },
  common: {
    action: '操作',
    add: '新增',
    addSuccess: '添加成功',
    backToHome: '返回首页',
    batchDelete: '批量删除',
    cancel: '取消',
    close: '关闭',
    check: '选择',
    expandColumn: '展开列',
    columnSetting: '列设置',
    config: '配置',
    confirm: '确认',
    delete: '删除',
    deleteSuccess: '删除成功',
    confirmDelete: '确认删除吗？',
    edit: '编辑',
    index: '序号',
    keywordSearch: '请输入关键词搜索',
    logout: '退出登录',
    logoutConfirm: '确认退出登录吗？',
    lookForward: '敬请期待',
    modify: '修改',
    modifySuccess: '修改成功',
    noData: '无数据',
    operate: '操作',
    pleaseCheckValue: '请检查输入的值是否合法',
    refresh: '刷新',
    reset: '重置',
    search: '搜索',
    switch: '切换',
    tip: '提示',
    trigger: '触发',
    update: '更新',
    updateSuccess: '更新成功',
    userCenter: '个人中心',
    yesOrNo: {
      yes: '是',
      no: '否'
    },
    handleImport: '导入',
    handleExport: '导出'
  },
  request: {
    logout: '请求失败后登出用户',
    logoutMsg: '用户状态失效，请重新登录',
    logoutWithModal: '请求失败后弹出模态框再登出用户',
    logoutWithModalMsg: '用户状态失效，请重新登录',
    refreshToken: '请求的token已过期，刷新token',
    tokenExpired: 'token已过期'
  },
  theme: {
    themeSchema: {
      title: '主题模式',
      light: '亮色模式',
      dark: '暗黑模式',
      auto: '跟随系统'
    },
    grayscale: '灰度模式',
    layoutMode: {
      title: '布局模式',
      vertical: '左侧菜单模式',
      'vertical-mix': '左侧菜单混合模式',
      horizontal: '顶部菜单模式',
      'horizontal-mix': '顶部菜单混合模式'
    },
    recommendColor: '应用推荐算法的颜色',
    recommendColorDesc: '推荐颜色的算法参照',
    themeColor: {
      title: '主题颜色',
      primary: '主色',
      info: '信息色',
      success: '成功色',
      warning: '警告色',
      error: '错误色',
      followPrimary: '跟随主色'
    },
    scrollMode: {
      title: '滚动模式',
      wrapper: '外层滚动',
      content: '主体滚动'
    },
    page: {
      animate: '页面切换动画',
      mode: {
        title: '页面切换动画类型',
        'fade-slide': '滑动',
        fade: '淡入淡出',
        'fade-bottom': '底部消退',
        'fade-scale': '缩放消退',
        'zoom-fade': '渐变',
        'zoom-out': '闪现',
        none: '无'
      }
    },
    fixedHeaderAndTab: '固定头部和标签栏',
    header: {
      height: '头部高度',
      breadcrumb: {
        visible: '显示面包屑',
        showIcon: '显示面包屑图标'
      }
    },
    tab: {
      visible: '显示标签栏',
      cache: '缓存标签页',
      height: '标签栏高度',
      mode: {
        title: '标签栏风格',
        chrome: '谷歌风格',
        button: '按钮风格'
      }
    },
    sider: {
      inverted: '深色侧边栏',
      width: '侧边栏宽度',
      collapsedWidth: '侧边栏折叠宽度',
      mixWidth: '混合布局侧边栏宽度',
      mixCollapsedWidth: '混合布局侧边栏折叠宽度',
      mixChildMenuWidth: '混合布局子菜单宽度'
    },
    footer: {
      visible: '显示底部',
      fixed: '固定底部',
      height: '底部高度',
      right: '底部局右'
    },
    themeDrawerTitle: '主题配置',
    pageFunTitle: '页面功能',
    configOperation: {
      copyConfig: '复制配置',
      copySuccessMsg: '复制成功，请替换 src/theme/settings.ts 中的变量 themeSettings',
      resetConfig: '重置配置',
      resetSuccessMsg: '重置成功'
    }
  },
  route: {
    login: '登录',
    403: '无权限',
    404: '页面不存在',
    500: '服务器错误',
    'iframe-page': '外链页面',
    'general-form': '业务详情',
    home: '首页',
    'user-center': '个人中心',
    sys: '系统管理',
    sys_dict: '字典管理',
    sys_account: '用户管理',
    sys_role: '角色管理',
    sys_department: '部门管理',
    sys_menu: '菜单管理',
    'sys_gen-entity': '数据表管理',
    'sys_biz-attachment-type': '附件类型管理',
    'sys_data-filter': '数据规则管理',
    attachment: '附件管理',
    exception: '异常页',
    exception_403: '403',
    exception_404: '404',
    exception_500: '500',
    finance: '账户管理',
    'finance_finance-transaction-record': '钱包账户',
    'finance_finance-wallet': '交易记录',
    store: '门店管理',
    'store_store-info': '门店信息',
    'customer-info': '客户管理',
    base: '基础设置',
    'base_product-info': '产品管理',
    inventory: '库存管理',
    'inventory_inventory-info': '库存信息',
    order: '订单管理',
    'order_order-info': '订单信息',
    'store_store-audit-record': '审核信息',
    'finance_finance-sale-plan': '销售计划',
    school: '商学院',
    'school_lecture-category': '课程分类',
    'school_lecture-course': '课程管理',
    'school_study-record': '学习记录',
    'base_vehicle-brand': '车型品牌管理',
    'base_vehicle-info': '车辆型号管理',
    'base_vehicle-oem': '车型厂商管理',
    'base_vehicle-series': '车辆车系管理',
    'store_store-supplier-info': '门店供应商管理',
    'store_service-type': '服务类别管理',
    'base_product-spu': '商品SPU管理',
    'order_store-purchase-order': '门店采购订单',
    'store_member-info': '客户管理',
    'store_member-vehicle-info': '客户车辆管理',
    'store_material-type': '门店物资类型',
    'store_material-item': '门店物资管理',
    'store_service-item': '服务项目管理',
    'store_material-transaction': '门店物资领用记录',
    'inventory_store-inventory-info': '门店库存管理',
    'order_store-warranty-order': '质保订单管理',
    'inventory_inventory-check-record': '盘点记录',
    'order_store-outbound-order': '出库单',
    'order_store-sale-order': '门店销售订单',
    'store_service-package': '服务套餐管理',
    'order_order-evaluation': '订单评价',
    'store_film-purchase-order': '车膜采购订单',
    appointment: '预约管理',
    'appointment_appointment-info': '预约管理',
    'store_commission-rule': '工时提成规则管理',
    'store_commission-rule-product-info': '车膜提成管理',
    'store_commission-rule-product-sku': '商品提成管理',
    'store_commission-rule-sale-price': '订单提成管理',
    'store_commission-rule-partner': '合伙人提成管理',
    'store_service-type-template': '服务类别模板管理',
    'store_service-item-template': '服务项目模板管理',
    'finance_film-quotation': '车膜报价',
    'store_member-service-package': '优惠券管理',
    'base_product-sku': '商品SKU管理',
    'certified-technician': '认证技师',
    'display-case': '案例展示',
    message: '留言管理',
    'appointment_appointment-distribution': '预约分配',
    statistics: '报表管理',
    'statistics_factory-sales-statistics': '工厂各销售成交统计报表',
    'report-platform': '平台报表',
    'report-platform_sales-amount': '工厂各销售成交统计报表',
    'report-platform_sales-analysis': '各销售人员数据分析',
    'report-platform_order-info': '客户各级门店采购流水',
    finance_sale_order_commission_record: '门店销售订单提成汇总',
    finance_sale_order_commission: '门店销售订单提成',
    finance_sale: '',
    finance_sale_order: '',
    'report-store': '',
    'report-store_transaction-records': '',
    'report-platform_product-sale-ranking': '产品销量统计表',
    'report-store_store-sale-order-commission': '',
    'report-store_store-employee-month-commission': '',
    'report-store_statistics-customer-info': '',
    'report-platform_customer-distribution': '客户分布表',
    'report-platform_inventory-statistics': '工厂库存管理表',
    'report-store_view-statistics-non-upgrade': '',
    'report-store_view-statistics-appointment-loss': '',
    'finance_sale-order-technician-commission': '',
    'finance_partner-commission-record': '',
    'store_store-customer': '客户信息',
    sys_miniapp: '',
    'appointment_appointment-audit': '预约审核',
    'appointment_appointment-loss': '门店客户流失',
    'inventory_circulating-inventory-info': '',
    'inventory_sales-record-info': '',
    base_warehouse: '仓库管理',
    'finance_finance-commission-details': '',
    'sale-tools': '',
    'sale-tools_st-category-quick': '',
    'sale-tools_st-category-section': '',
    'sale-tools_st-survey-option': '',
    'sale-tools_st-survey-question': '',
    'sale-tools_st-solution': '',
    'sale-tools_st-survey-answer': '',
    'sale-tools_st-survey-quick': '',
    'sale-tools_st-user-tracking': '',
    'store_circulation-info': '',
    'order_film-purchase-order-payment-log': '',
    'order_store-sale-order-payment-log': '',
    'sale-tools_store-info-edit': '',
    'sale-tools_st-cm-mod-item': '',
    'sale-tools_st-cm-vehicle-zones': '',
    'report-store_purchase-order-credit': '',
    'report-store_purchase-order-credit-settlement': '',
    'report-store_sale-order-credit': '',
    'report-store_sale-order-credit-settlement': '',
    'store_store-sale-order-circulation': '',
    'sale-tools_st-category-section-share': '',
    'sale-tools_st-survey-share': '',
    'order_film-purchase-credit': '',
    'inventory_inventory-allocated-record': '',
    'sys_dict-extra': ''
  },
  page: {
    login: {
      common: {
        loginOrRegister: '登录 / 注册',
        userNamePlaceholder: '请输入用户名',
        phonePlaceholder: '请输入手机号',
        codePlaceholder: '请输入验证码',
        passwordPlaceholder: '请输入密码',
        confirmPasswordPlaceholder: '请再次输入密码',
        codeLogin: '验证码登录',
        confirm: '确定',
        back: '返回',
        validateSuccess: '验证成功',
        loginSuccess: '登录成功',
        welcomeBack: '欢迎回来，{userName} ！'
      },
      pwdLogin: {
        title: '密码登录',
        rememberMe: '记住我',
        forgetPassword: '忘记密码？',
        register: '注册账号',
        otherAccountLogin: '其他账号登录',
        otherLoginMode: '其他登录方式',
        superAdmin: '超级管理员',
        admin: '管理员',
        user: '普通用户'
      },
      codeLogin: {
        title: '验证码登录',
        getCode: '获取验证码',
        reGetCode: '{time}秒后重新获取',
        sendCodeSuccess: '验证码发送成功',
        imageCodePlaceholder: '请输入图片验证码'
      },
      wxcpLogin: {
        title: '企业微信登录'
      },
      register: {
        title: '注册账号',
        agreement: '我已经仔细阅读并接受',
        protocol: '《用户协议》',
        policy: '《隐私权政策》'
      },
      resetPwd: {
        title: '重置密码'
      },
      bindWeChat: {
        title: '绑定微信'
      }
    },
    home: {
      greeting: '早安，{userName}, 今天又是充满活力的一天!',
      weatherDesc: '今日多云转晴，20℃ - 25℃!',
      projectCount: '项目数',
      todo: '待办',
      message: '消息',
      downloadCount: '下载量',
      registerCount: '注册量',
      schedule: '作息安排',
      study: '学习',
      work: '工作',
      rest: '休息',
      entertainment: '娱乐',
      visitCount: '访问量',
      turnover: '成交额',
      dealCount: '成交量',
      projectNews: {
        title: '项目动态',
        moreNews: '更多动态'
      },
      creativity: '创意'
    }
  },
  form: {
    required: '不能为空',
    userName: {
      required: '请输入用户名',
      invalid: '用户名格式不正确'
    },
    phone: {
      required: '请输入手机号',
      invalid: '手机号格式不正确'
    },
    pwd: {
      required: '请输入密码',
      invalid: '密码格式不正确，6-18位字符，包含字母、数字、下划线'
    },
    confirmPwd: {
      required: '请输入确认密码',
      invalid: '两次输入密码不一致'
    },
    code: {
      required: '请输入验证码',
      invalid: '验证码格式不正确'
    },
    email: {
      required: '请输入邮箱',
      invalid: '邮箱格式不正确'
    }
  },
  dropdown: {
    closeCurrent: '关闭',
    closeOther: '关闭其它',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    closeAll: '关闭所有'
  },
  icon: {
    themeConfig: '主题配置',
    themeSchema: '主题模式',
    lang: '切换语言',
    fullscreen: '全屏',
    fullscreenExit: '退出全屏',
    reload: '刷新页面',
    collapse: '折叠菜单',
    expand: '展开菜单',
    pin: '固定',
    unpin: '取消固定'
  }
};

export default local;
